import { FC, useMemo } from 'react';
import { Checkbox } from '@dynamika-shared/ui/Checkbox/Checkbox';
import { twMerge } from '@utils/twMerge';

export type GenericItem = {
  id: string | number;
  name: string;
};

type CheckboxListProps = {
  items?: Record<string, GenericItem[]>;
  selectedItems: string[];
  onItemToggle: (item: GenericItem) => void;
  disabled?: boolean;
};

export const CheckboxList: FC<CheckboxListProps> = ({
  items,
  selectedItems,
  onItemToggle,
  disabled,
}) => {
  const selectedItemsSet = useMemo(
    () => new Set(selectedItems),
    [selectedItems]
  );

  if (!items) return null;

  return (
    <div className='flex flex-col gap-4 mt-4'>
      {Object.entries(items).map(([group, groupItems]) => (
        <div key={group}>
          {group !== 'hidden' && (
            <h3 className={'font-semibold text-lg mb-2'}>{group}</h3>
          )}
          <div className='flex items-center flex-wrap gap-2'>
            {groupItems.map((item, index) => (
              <div
                className={twMerge(
                  'flex items-center gap-1 pl-2',
                  index && 'border-l border-[#B4BDD3]'
                )}
                key={item.id}
              >
                <label className='flex items-center gap-1'>
                  <Checkbox
                    checked={selectedItemsSet.has(item.id as string)}
                    onChange={() => onItemToggle(item)}
                    disabled={disabled}
                  />
                  <span className='font-medium text-1420 h-auto whitespace-nowrap'>
                    {item.name}
                  </span>
                </label>
              </div>
            ))}
          </div>
        </div>
      ))}
    </div>
  );
};
